import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  hasConsent,
  acceptAll,
  rejectAll,
  onOpenCookieSettings,
} from "../../../utils/cookieConsent.js";
import CookieSettingsModal from "./CookieSettingsModal.jsx";

/**
 * Bannière de consentement cookies (RGPD).
 * S'affiche tant qu'aucun choix n'a été enregistré.
 * Le lien « Paramètres des cookies » du footer ouvre la modale.
 */
export default function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(!hasConsent());
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    return onOpenCookieSettings(() => setModalOpen(true));
  }, []);

  // Le pré-rendu statique ne doit PAS figer la bannière dans le HTML : sinon un
  // visiteur déjà consentant la voit « flasher » puis disparaître au boot.
  if (typeof window !== "undefined" && window.__PRERENDER__) return null;

  if (!visible) {
    return <CookieSettingsModal open={modalOpen} onClose={() => setModalOpen(false)} />;
  }

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-[9998]">
        <div className="mx-auto max-w-4xl bg-white shadow-[0_-4px_24px_rgba(0,0,0,0.12)] border-t border-gray-100 px-6 py-5">
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            <div className="flex-1">
              <p className="text-[15px] font-semibold text-gray-900">
                {t("cookieConsent.bannerTitle")}
              </p>
              <p className="mt-1 text-[13px] leading-relaxed text-gray-600">
                {t("cookieConsent.bannerText")}
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 shrink-0">
              <button
                onClick={() => setModalOpen(true)}
                className="inline-flex items-center justify-center rounded-full border border-gray-300 px-5 py-2.5 text-[14px] font-medium text-gray-700 transition hover:bg-gray-50"
              >
                {t("cookieConsent.customize")}
              </button>
              <button
                onClick={() => {
                  rejectAll();
                  setVisible(false);
                }}
                className="inline-flex items-center justify-center rounded-full border border-gray-300 px-5 py-2.5 text-[14px] font-medium text-gray-700 transition hover:bg-gray-50"
              >
                {t("cookieConsent.decline")}
              </button>
              <button
                onClick={() => {
                  acceptAll();
                  setVisible(false);
                }}
                className="inline-flex items-center justify-center rounded-full bg-[#976DD0] px-5 py-2.5 text-[14px] font-semibold text-white transition hover:bg-[#8557C0]"
              >
                {t("cookieConsent.accept")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <CookieSettingsModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}